/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { CurrentUserService } from 'app/core/user/current-user.service';

/**
 * The navigation tree, gated on the signed-in member's claims.
 *
 * This used to decode the token itself at module scope. It takes CurrentUserService instead so
 * that importing the module no longer requires a signed-in browser — NavigationService, which is
 * injectable, supplies it.
 */
export const buildDefaultNavigation = (currentUser: CurrentUserService): FuseNavigationItem[] => [
    // {
    //     id   : 'example',
    //     title: 'Home',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : '/'
    // },
    // {
    //     id   : 'new-members',
    //     title: 'New Members',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : '/new-members'
    // },
    // {
    //     id   : 'solicitations',
    //     title: 'Solicitations',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : '/solicitations'
    // },
    // {
    //     id   : 'working-groups-exp',
    //     title: 'Working Groups',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : '/working-groups'
    // },
    // {
    //     id   : 'working-groups',
    //     title: 'Document Test',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : '/working-groups-tst'
    // },
    // {
    //     id   : 'app-resources',
    //     title: 'Resources',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : '/resources'
    // },
    // {
    //     id   : 'example',
    //     title: 'NSC News and Events',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : 'https://www.nationalspectrumconsortium.org/news',
    //     externalLink : true,
    //     target : '_blank'
    // },
    // {
    //     id   : 'app-social-media',
    //     title: 'Follow Us on Social Media',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : '/social-media'
    // },
    {
        id   : 'document-list',
        title: 'Document Management',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/document-list',
        hidden : (item) => {
            return !currentUser.isAdmin();
        },
    },
    {
        id   : 'image-list',
        title: 'Image Management',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/image-list',
        hidden : (item) => {
            return !currentUser.isAdmin();
        },
    },
    //TODO: rev
    {
        id   : 'news-list',
        title: 'News Article Management',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/news-list',
        hidden : (item) => {
            return !currentUser.isAdmin();
        },
    },
    {
        id   : 'career-list',
        title: 'Career Posting Management',
        type : 'basic',
        icon : 'heroicons_outline:briefcase',
        link : '/career-list',
        hidden : () => !currentUser.isAdmin(),
    },
    {
        id   : 'award-list',
        title: 'Project Award Management',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/award-list',
        hidden : (item) => {
            return !currentUser.isAdmin();
        },
    },
    {
        id   : 'submission-admin',
        title: 'Submission Management',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/submission-request-list',
        hidden : (item) => {
            return !currentUser.isAdmin();
        },
    },
    {
        id   : 'content-admin',
        title: 'Content Card Management',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/content-list',
        hidden : (item) => {
            return !currentUser.isAdmin();
        },
    },
    {
        id   : 'page-admin',
        title: 'Page Management',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/content-editor-list',
        hidden : (item) => {
            return !currentUser.isAdmin();
        },
    },
    {
        id   : 'user-manager',
        title: 'User Management',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/user-manager',
        hidden : () => !currentUser.canManageUsers(),
    },
    {
        id   : 'fileshare-manager',
        title: 'Member Fileshare Management',
        type : 'basic',
        icon : 'heroicons_outline:folder-open',
        link : '/fileshare-manager',
        hidden : () => !currentUser.isAdmin(),
    },
    {
        id   : 'member-files',
        title: 'Member Files',
        type : 'basic',
        icon : 'heroicons_outline:folder',
        link : '/fileshare/me',
        hidden : () => currentUser.isAdmin(),
    },
];
